import { KibTopLevelAlert } from '@chewy/kib-messaging-react'

import '@chewy/kib-messaging-styles/dist/styles/kib-alert-icon.css'
import '@chewy/kib-messaging-styles/dist/styles/kib-top-level-alert.css'
import styles from './CancelErrorBanner.module.scss'

interface CancelErrorBannerProps {
  message: string
}

export const CancelErrorBanner = ({ message }: CancelErrorBannerProps) => {
  if (!message) {
    return null
  }

  return (
    <KibTopLevelAlert
      className={styles.cancelErrorBanner}
      heading={message}
      severity="error"
    />
  )
}
